export default __webpack_public_path__ + "static/media/FS-LOGO-BLANCO.707eda71.svg";